<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/productManage',title:'产品管理'},{title:'产品创建'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail17">
                                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                                :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="业务类型" prop="ywlx" 
                                                :rules="[{ required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="IN_TYPE" :v="zy.ywlx" v-model="zy.ywlx" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxh">
                                                <el-input placeholder="请输入" v-model="zy.wlxh" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="基本单位" prop="jbdw" 
                                                :rules="[{ required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLUnit" :v="zy.jbdw" v-model="zy.jbdw" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="物料组" prop="wlz" 
                                                :rules="[{ required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <template>
                                                <brselectlazy category="YLMaterialGroup" :v="zy.wlz" v-model="zy.wlz" disabled="disabled"></brselectlazy>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="旧物料号" class="h-elformWrap-2" prop="jwlh">
                                                <el-input placeholder="请输入" v-model="zy.jwlh" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品组" prop="cpz" 
                                                :rules="[{ required: false, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLProductGroup" :v="zy.cpz" v-model="zy.cpz" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="实验室" prop="sys" 
                                                :rules="[{ required: false, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="Laboratory" :v="zy.sys" v-model="zy.sys" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="外部物料组" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.wbwlz" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="税分类" prop="sfl" 
                                                :rules="[{ required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLMtlTaxType" :v="zy.sfl" v-model="zy.sfl" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="产品注册号" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cpzch" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="储运条件" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cytj" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cd" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品层次" prop="cpcc" 
                                                :rules="[{ required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <template>
                                                <brselectlazy category="YLProdHierarchy" :v="zy.cpcc" v-model="zy.cpcc" disabled="disabled"></brselectlazy>
                                                </template>
                                            </el-form-item>
                                            <el-form-item label="生产商" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.scs" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="小微编码" prop="xwbm" 
                                                :rules="[{ required: false, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLXW" :v="zy.xwbm" v-model="zy.xwbm" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="生态硬件属性" prop="styjsx" 
                                                :rules="[{ required: false, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLEcology" :v="zy.styjsx" v-model="zy.styjsx" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="生态收入" prop="stsr" 
                                                :rules="[{ required: false, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                                                <brselect category="YLEcologyIn" :v="zy.stsr" v-model="zy.stsr" disabled="disabled"></brselect>
                                            </el-form-item>
                                            <el-form-item label="产品有效期" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.youxiaoqi" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="上传凭证" class="h-elformWrap-1" prop="upload">
                                                <brupload
                                                    :refid="chanpinid"
                                                    :reftype="chanpinziliao"
                                                    >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="行业标准描述" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.hybzms" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建人账号" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cjrzh" disabled="disabled"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin: 0.2rem 0  0.3rem 0;">
                    <h1>真实物料审批</h1>
                </div>
                <div class="" style="width:100%;padding:10px;background:#fcfcfc;border:1px solid #ccc">
                    <div class="h-formLine weekplandetail17">
                        <el-form :model="zhenshiwuliao" label-position="right" ref="zhenshiwuliao" :inline="true" :rules="rulestwo" class="demo-ruleForm h-formbLine">
                            <div class="h-txtLeft h-mrt60">
                                <el-form-item label="审批意见" class="h-elformWrapz-2" prop="shenheyijian" style="margin-top:-25px;">
                                    <el-input v-model="zhenshiwuliao.shenheyijian" placeholder="审批意见" ></el-input>
                                </el-form-item>
                                <br>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div> -->
            <div class="h-table h-mrt30 jjjj ">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:20px">审批意见</h1>
                    <el-form :model="zhenshiwuliao" label-position="right" :inline="true"
                        class="demo-ruleForm h-formbLine " ref="zhenshiwuliao">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " prop="shenheyijian" required="true"
                            :rules="[ { required: true, message: '审批意见不能为空', trigger: ['blur', 'change']},]"
                            style="margin:30px 0 20px 23px">
                            <el-input v-model="zhenshiwuliao.shenheyijian"  placeholder="请输入"
                                :disabled="taskstatus==1">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="anniu">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgred" @click="bohuianniu" v-if="taskstatus==0">驳回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="tongguoanniu" v-if="taskstatus==0">通过</el-button>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                taskstatus:'',
                //初始获取的审批流的参数
                chushihuoqu:{},
                //审批提示信息
                tishixinxi:'',
                //是否已提交过通过驳回
                shifouyitijiaotongguobohui:false,
                //通过还是驳回
                tonguoorbohui:1,
                zhenshiwuliao:{
                    shenheyijian:'',
                },
                //taskid
                taskid:'',
                YLProdHierarchyList:[],
                YLMaterialGroupList:[],
                qianyeshuju:{},
                //小微编码
                xiaoweibianma:[{
                    value: '',
                    label: '--请选择--'
                },],
                //生态收入
                shengtaishouru:[{
                    value: '',
                    label: '--请选择--'
                },],
                //生态硬件属性
                shengtaiyingjianshuxing:[{
                    value: '',
                    label: '--请选择--'
                },],
                //产品层次
                chanpincengci:[{
                    value: '',
                    label: '--请选择--'
                },],
                //税分类
                shuifenlei:[{
                    value: '',
                    label: '--请选择--'
                },],
                //实验室
                shiyanshi:[{
                    value: '',
                    label: '--请选择--'
                },],
                //产品组
                chanpinzu:[{
                    value: '',
                    label: '--请选择--'
                },],
                //物料组
                wuliaozu:[{
                    value: '',
                    label: '--请选择--'
                },],
                //基本单位
                jibendanwei:[{
                    value: '',
                    label: '--请选择--'
                },],
                //物料id
                chanpinid: '',
                //资料类型名称
                chanpinziliao: 'shangchuanpingzheng',
				ywlxxuanxiang:[
                    {
                        value: '',
                        label: '--请选择--'
                    },

					{
						value: 'SH',
						label: '上海OEM'
					}, {
						value: 'HK',
						label: '香港OEM'
					}
				],
                options1: [{
                    value: '选项1',
                    label: '渠道1'
                }, {
                    value: '选项2',
                    label: '渠道2'
                }],
                options2: [{
                    value: '选项1',
                    label: '分类1'
                }, {
                    value: '选项2',
                    label: '分类2'
                }],
                options3: [{
                    value: '选项1',
                    label: '大类1'
                }, {
                    value: '选项2',
                    label: '大类2'
                }],
                options4: [{
                    value: '选项1',
                    label: '大类1'
                }, {
                    value: '选项2',
                    label: '大类2'
                }],
                options5: [{
                    value: '选项1',
                    label: '型号1'
                }, {
                    value: '选项2',
                    label: '型号2'
                }],
                zy: {
                    ywlx: null,
                    wlxh: null,
                    wlms: null,
                    jbdw: null,
                    wlz: null,
                    jwlh: null,
                    cpz: null,
                    sys: null,
                    wbwlz: null,
                    sfl: null,
                    cpzch: null,
                    cytj: null,
                    cd: null,
                    cpcc: null,
                    scs: null,
                    xwbm: null,
                    styjsx: null,
                    stsr: null,
                    youxiaoqi: null,
                    pingzheng: null,
                    hybzms: null,
                    cjrzh: null,
                },
                // cities: cityOptions,
                rules: {
                    ywlx: [
                        {required: true, message: '请选择业务类型', trigger: 'blur'}
                    ],
                    wlxh: [
                        {required: true, message: '请选择物料型号', trigger: 'blur'}
                    ],
                    wlms: [
                        {required: true, message: '请输入物料描述', trigger: 'blur'}
                    ],
                    jbdw: [
                        {required: true, message: '请选择基本单位', trigger: 'blur'}
                    ],
                    wlz: [
                        {required: true, message: '请选择物料组', trigger: 'blur'}
                    ],
                    jwlh: [
                        {required: true, message: '请输入旧物料号', trigger: 'blur'}
                    ],
                    sfl: [
                        {required: true, message: '请选择税分类', trigger: 'blur'}
                    ],
                    cpcc: [
                        {required: true, message: '请选择产品层次', trigger: 'blur'}
                    ],

                },

                // rulestwo: {
                //     shenheyijian: [
                //         { required: true, message: '不能为空', trigger: 'blur' },
                //     ],
                // },
            }
        },


        //加载页面默认执行
        created() {

            console.log(this.$route.query,'看看是啥玩意')
            //若有前页数据
            if(this.$router.history.current.query!=null){
                this.idmsg = this.$router.history.current.query.ywid||null;
                this.chushihuoqu = this.$router.history.current.query;
                //前页数据
                this.qianyeshuju = this.$router.history.current.query;
                //taskid
                this.taskid = this.$router.history.current.query.taskid||null;
                this.taskstatus = this.$route.query.taskstatus;
                //物料编号
                this.chanpinid = this.$router.history.current.query.xuniwuliao||this.$router.history.current.query.ywid;
                var chushicanshu = {
                    materialCode:this.$router.history.current.query.materialCode||this.$router.history.current.query.ywid,
                    xuniwuliao:this.$router.history.current.query.xuniwuliao||this.$router.history.current.query.ywid,
                    rowId:this.$router.history.current.query.rowId||null,
                };
                //获取信息
                this.gettableels(chushicanshu);
            }else{
                //一打开新建页面就先给上一个新的uuid作为物料编码
                this.chanpinid = this.$util.getUuid();
            }
            //加载登陆人账号
            this.zy.cjrzh = this._user.usercode;
            //加载配置项
            this.huoquprizhixiang();
        },
        //监听
        watch: {},
        methods: {
            //通过按钮
            tongguoanniu(){
                this.tonguoorbohui = 2;
                this.tijiaogengxinzhuangtai();
            },
            //提交更新审核状态
            tijiaogengxinzhuangtai(){
                console.log('chushihuoqu',this.chushihuoqu)
                var sid = {
                    yewuzhujian:this.idmsg,
                    taskid:this.chushihuoqu.taskid,
                    optflag:this.tonguoorbohui==1?'驳回':'通过',
                    msg:this.zhenshiwuliao.shenheyijian,
                    tongguoorbohui:this.tonguoorbohui,//通过还是驳回 1驳回  2通过
                    jiediantiaojianming:'tongguoorbohui',//审核节点条件名
                }
                ss.chanpin.overzhenwuliaoshenpi(sid).then(rd => {

                    if(rd.f){
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        })
                        // this.quxiaoanniu();
                    }else{

                        this.$msg.msge(rd.msg)

                    }
                })
            },
            //取消按钮
            quxiaoanniu(){
                //返回首页
                this.$router.push({ path: '/personal/dealCenter'});
            },
            //驳回按钮
            bohuianniu(){
                this.tonguoorbohui = 1;
                this.$refs.zhenshiwuliao.validate((valid) => {
                    if (valid) {
                        this.tijiaogengxinzhuangtai();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //加载配置项
            gettableels(q) {
                ss.chanpin.idaorrowIdbselectList(q).then(rd => {
                    console.log(rd.obj,'???,,,???')
                    this.vw = rd.obj;
                    var ss = {
                        ywlx: rd.obj.oemType||'',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
                        wlms: rd.obj.materialDescrition||'',// 物料描述   //产品型号
                        jbdw: rd.obj.primaryUom||'',//基本计量单位
                        wlz: rd.obj.materialGroupCode||'',//物料组
                        jwlh: rd.obj.oldMaterialNumber||'',// 旧物料号
                        cpz: rd.obj.department||'',//产品组
                        sys: rd.obj.labStudio||'',//实验室/办公室
                        wbwlz: rd.obj.extMtlGroup||'',//外部物料组
                        sfl: rd.obj.tax||'',//税分类
                        cpzch: rd.obj.productRegNum||'',//产品注册号
                        cytj: rd.obj.shipCondition||'',//储运条件
                        cd: rd.obj.placeOrigin||'',//产地
                        cpcc: rd.obj.productHierarchy||'',//产品层次  (关联产品层级编码id)
                        scs: rd.obj.manufacturer||'',//生产商
                        xwbm: rd.obj.zattr5u||'',//小微编码
                        styjsx: rd.obj.ecology||'',//生态硬件属性
                        stsr: rd.obj.ecologyIn||'',//生态收入
                        youxiaoqi: rd.obj.zcpyxq||'',//产品有效期(年)
                        hybzms: rd.obj.industryStdDesc||'',//行业标准描述
                        cjrzh: rd.obj.cucode||'',//创建人编码
                        wlxh: rd.obj.materialDescrition||'',// 物料描述   //产品型号
                    }
                    this.zy = ss;
                })
            },
            zancunortijiao(q) {
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        var canshu = {
                            id: this.chanpinid,//虚拟物料id
                            materialCode: this.chanpinid,// 真实物料id里先也存一个虚拟物料id
                            oemType: this.zy.ywlx,
                            materialDescrition: this.zy.wlxh,
                            primaryUom: this.zy.jbdw,
                            materialGroupCode: this.zy.wlz,
                            oldMaterialNumber: this.zy.jwlh,
                            Department: this.zy.cpz,
                            labStudio: this.zy.sys,
                            extMtlGroup: this.zy.wbwlz,
                            Tax: this.zy.sfl,
                            productRegNum: this.zy.cpzch,
                            shipCondition: this.zy.cytj,
                            placeOrigin: this.zy.cd,
                            productHierarchy: this.zy.cpcc,
                            manufacturer: this.zy.scs,
                            zattr5u: this.zy.xwbm,
                            ecology: this.zy.styjsx,
                            ecologyIn: this.zy.stsr,
                            zcpyxq: this.zy.youxiaoqi,
                            industryStdDesc: this.zy.hybzms,
                            cucode: this.zy.cjrzh,
                        }
                        if (q == 0) {//暂存
                            this.zancun(canshu);
                        } else {//提交
                            this.querentijiao(canshu);
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //获取配置项
            huoquprizhixiang(){

            },
            querentijiao(q) {
                ss.chanpin.addtijiao(q).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.fanhui();
                })
            },
            zancun(q) {
                ss.chanpin.addzancun(q).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.chanpinid = rd.obj.xuniwuliao;
                    var ss = {
                        ywlx: rd.obj.oemType,
                        wlxh: rd.obj.materialDescrition,
                        jbdw: rd.obj.primaryUom,
                        wlz: rd.obj.materialGroupCode,
                        jwlh: rd.obj.oldMaterialNumber,
                        cpz: rd.obj.department,
                        sys: rd.obj.labStudio,
                        wbwlz: rd.obj.extMtlGroup,
                        sfl: rd.obj.tax,
                        cpzch: rd.obj.productRegNum,
                        cytj: rd.obj.shipCondition,
                        cd: rd.obj.placeOrigin,
                        cpcc: rd.obj.productHierarchy,
                        scs: rd.obj.manufacturer,
                        xwbm: rd.obj.zattr5u,
                        styjsx: rd.obj.ecology,
                        stsr: rd.obj.ecologyIn,
                        youxiaoqi: rd.obj.zcpyxq,
                        hybzms: rd.obj.industryStdDesc,
                        cjrzh: rd.obj.cucode
                    }
                    this.zy = ss;
                })
            },
            //返回上一页
            fanhui() {
                this.$router.push({path: '/chanp/productManage'});
            },
        }
    }
</script>
<style scoped>
    .zancun {
        padding: 0.18rem 0.42rem;
    }
    .queren {
        background-color: #006aca;
        color: white;
        padding: 0.18rem 0.42rem;
    }
    .zancun{
        background-color: #24b5b8;
        color: white;
    }
    .anniu {
        margin-left: 6rem;
        margin-top: 30px;
    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .weekplandetail17 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }
    .jjjj .h-formbLine .el-form-item__label{
        width:17%;
    }
	.jjjj .h-formbLine .el-form-item__content{
        width:83%;
    }
    .weekplandetail17 .h-formbLine .el-form-item__content{
        width: 66%;
    }
    .weekplandetail17 .h-formbLine .h-elformWrap-2{
        width: 33.333%;
        padding-right: 0.5rem
    }
    .weekplandetail17 .h-formbLine .h-elformWrap-1{
        width: 100%;
        padding-right: 0.5rem
    }
    .weekplandetail17 .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 9.7%;
    }
    .weekplandetail17 .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 90.3%;
    }
    .weekplandetail17 .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .weekplandetail17  .h-formbLine .el-form-item__content .el-input{
         width: 100%!important;
    }
</style>
